import Vue from '../../../lib/utils/vue3compat/vue.js?vue3';
import VueApollo from '../../../lib/utils/vue3compat/vue_apollo.js?vue3';
import { parseBoolean } from '@gitlab/frontend-utils';
import { initVueApp } from '../../../lib/utils/vue3compat/init_vue_app.js?vue3';
import createDefaultClient from '../../../lib/graphql.js?vue3';
import GroupActionsApp from './components/app.vue?vue3';
import { convertObjectPropsToCamelCase } from '~/lib/utils/common_utils';
import { formatGroup } from './formatter.js?vue3';

Vue.use(VueApollo);

const apolloProvider = new VueApollo({
  defaultClient: createDefaultClient(),
});

export const initGroupActions = () => {
  const el = document.querySelector('#js-group-more-actions-dropdown');

  if (!el) return null;

  const { dashboardPath, canWithdrawAccessRequest, canRequestAccess } =
    convertObjectPropsToCamelCase(el.dataset);

  const baseGroup = JSON.parse(el.dataset.group);
  const group = formatGroup(baseGroup, {
    canWithdrawAccessRequest: parseBoolean(canWithdrawAccessRequest),
    canRequestAccess: parseBoolean(canRequestAccess),
  });

  return initVueApp({
    el,
    name: 'GroupActionsApp',
    apolloProvider,
    provide: {
      triggerDeleteLocation: 'header',
      triggerRestoreLocation: 'header',
    },
    component: GroupActionsApp,
    props: { group, dashboardPath },
  });
};
